// import * as React from 'react';
import { FC } from 'react'
// import { useGetIdentity, useNotify } from 'react-admin';

import AppState from 'shared/app_state'

interface AccountScopedProps {
  children: (accountId: string, props?: { [key: string]: any }) => any
  componentProps?: any
  view?: string
}

export const AccountScoped: FC<AccountScopedProps> = ({ children, view, componentProps }) => {
  // const notify = useNotify();
  // const { identity, loading: identityLoading } = useGetIdentity();

  // if (identityLoading) return null;
  // const { account } = identity;

  const account = AppState.getCurrentAccount()

  if (!account || !account.id) {
    // notify('This view is only accessible to registered account members.');
    console.log(view || 'This view', 'is only accessible to registered account members.')
    return null
  }

  const { id: accountId } = account

  return children(accountId, componentProps)
}
